import React from 'react';
import PropTypes from 'prop-types'
import styles from './status-dropdown.styles.css';
import StatusDropdown from './status-dropdown.component.js';
import { CprTooltip } from 'canopy-styleguide!sofe';

// This component, and what it uses, are being exported
// and are shared to other projects
export default class StatusInput extends React.Component {
  static propTypes = {
    statuses: PropTypes.array,
    selectedStatus: PropTypes.string,
    updateTaskStatus: PropTypes.func,
    updateStatuses: PropTypes.func,
  }
  state = {
    dropdown: false,
  };

  render() {
    const selectedStatus = this.props.statuses.find(
      status => status.id === this.props.selectedStatus
    ) || { name: 'Loading statuses', color: '#FFF' };
    const { condenseContainer, alignDropdownRight, statusNameMaxWidth } = this.props;
    return (
      <div className={`${styles.statusContainer} cps-body-sm`}>
        <div onClick={this.showDropdown} className={`${styles.statusInput}`}>
          <div className={`${styles.statusInfo}`}>
            <CprTooltip html={selectedStatus.name}>
              <div
                style={{ background: selectedStatus.color }}
                className={`${condenseContainer ? styles.statusDotCondensed : styles.statusDot} ${selectedStatus.name == "No status" ? styles.noStatusBorder : ""}`}
              />
            </CprTooltip>
            <span className={`${condenseContainer ? "cps-hidden" : styles.statusName} cps-ellipsis`}>
              {selectedStatus.name}
            </span>
          </div>
          <span className={`${condenseContainer ? "cps-hidden" : styles.downCaret}`} />
        </div>
        {this.state.dropdown &&
          <StatusDropdown
            userId={this.props.userId}
            statuses={this.props.statuses}
            close={this.hideDropdown}
            updateTaskStatus={this.props.updateTaskStatus}
            updateStatuses={this.props.updateStatuses}
            selectedStatus={selectedStatus}
            alignDropdownRight={alignDropdownRight}
            statusNameMaxWidth={statusNameMaxWidth}
            width={this.props.width}
          />}
      </div>
    );
  }
  showDropdown = () => {
    this.setState({
      dropdown: true,
    });
  };
  hideDropdown = () => {
    this.setState({
      dropdown: false,
    });
  };
}
